import type { MedicalRecordInput } from "@/lib/validations/medical-record";
import type { MedicalRecordSection } from "@/components/medical-records/mobile/medical-record-mobile.types";

export const hasValue = (value: unknown): boolean => {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return value.trim().length > 0;
  if (typeof value === "number") return !Number.isNaN(value);
  if (value instanceof Date) return !Number.isNaN(value.getTime());
  return true;
};

const SECTION_FIELDS: Record<MedicalRecordSection, Array<keyof MedicalRecordInput>> = {
  anamnesis: ["chief_complaint", "history", "behavior", "diet", "environment"],
  "physical-exam": [
    "weight",
    "temperature",
    "heart_rate",
    "respiratory_rate",
    "mucous_membranes",
    "capillary_refill_time",
    "hydration_status",
    "lymph_nodes",
    "cardiac_auscultation",
    "respiratory_auscultation",
    "abdominal_palpation",
    "locomotor_system",
    "skin_coat",
    "other_systems",
  ],
  diagnosis: [
    "presumptive_diagnosis",
    "definitive_diagnosis",
    "register_death",
    "death_date",
    "death_cause",
  ],
  treatment: ["treatment", "follow_up_date", "follow_up_notes"],
};

export function hasMedicalRecordSectionData(
  section: MedicalRecordSection,
  values: MedicalRecordInput,
): boolean {
  return SECTION_FIELDS[section].some((field) => hasValue(values[field]));
}

export function getPopulatedMedicalRecordSections(
  values: MedicalRecordInput,
): MedicalRecordSection[] {
  return (Object.keys(SECTION_FIELDS) as MedicalRecordSection[]).filter((section) =>
    hasMedicalRecordSectionData(section, values),
  );
}
